@if (showMarketHelp()) {
    <ms-market-help [optionGroup]="optionGroup()" [eventHelpText]="eventHelpText()" />
}
<div class="correct-score-compact-view">
    @for (participant of event().participants; let i = $index; track participant) {
        <div class="participant-compact-view">
            <ms-participant-image
                class="participant-logo"
                [participantImage]="participant.image"
                [sportId]="event().sport.id"
                [showLogoColor]="false" />
            <ms-scoreboard-participant
                class="participant-info"
                [event]="event()"
                [participant]="participant"
                [showIndicator]="true"
                [isNewEDPScoreboard]="true" />
            <ms-odd-increment-decrement
                class="increment-decrement-button"
                [position]="i"
                [participantScore]="getCurrentScores()[i]"
                [participantLiveScore]="getCurrentScores()[i]"
                (changeScoreEvent)="changeScoreEvent($event)" />
        </div>
    }
</div>

<div class="option-group-container">
    @if (currentScoreOption(); as option) {
        <ms-option
            [tracking]="{ source: tracking(), moduleType: trackingModuleType() }"
            [option]="option"
            [optionGroup]="optionGroup()"
            [event]="event()"
            [showPromoBadge]="!!crmPromotedOptionIdsMap()[option.id.toString()]"
            [sourceOfPick]="sourceOfPick()"
            [betDetails]="betDetails()"
            [showOptionName]="false" />
    } @else {
        <div class="option">
            <div class="option-pick">
                <div class="offline option-indicator">
                    <div class="lock" [class]="isEpcotEnabled ? 'option-group-lock-i-icon' : 'option-group-lock-icon'">
                        <vn-icon name="theme-locked-i" [size]="isEpcotEnabled ? '16' : '14'" />
                    </div>
                </div>
            </div>
        </div>
    }
</div>
